import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatBadgeModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatSidenavModule,
  MatMenuModule,
  MatListModule,
  MatDividerModule,
  MatGridListModule,
  MatExpansionModule,
  MatTabsModule,
  MatCardModule,
  MatStepperModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatCheckboxModule,
  MatRadioModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatDialogModule,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatSliderModule,
  MatProgressBarModule,
  MatBottomSheetModule
} from '@angular/material';

import { BilUploadedDocumentPipe } from '@core/configs/bil-uploaded-document.pipe';
import { BilbilConvertToNumberPipe } from '@core/configs/bil-convert-to-number.pipe';
import { BilCurrencyPipe } from '@core/configs/bil-currency.pipe';

const MaterialModuleUsed = [
  MatButtonModule,
  MatButtonToggleModule,
  MatBadgeModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatSidenavModule,
  MatMenuModule,
  MatListModule,
  MatDividerModule,
  MatGridListModule,
  MatExpansionModule,
  MatTabsModule,
  MatCardModule,
  MatStepperModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatCheckboxModule,
  MatRadioModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatDialogModule,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatSliderModule,
  MatProgressBarModule,
  MatBottomSheetModule
];

@NgModule({
  imports: [MaterialModuleUsed],
  exports: [MaterialModuleUsed, BilUploadedDocumentPipe, BilbilConvertToNumberPipe, BilCurrencyPipe],
  declarations: [BilUploadedDocumentPipe, BilbilConvertToNumberPipe, BilCurrencyPipe]
})
export class BilMaterialModule { }
